// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React from 'react';
import {ROUTES, PRIVACY_POLICY_LINK, NEW_TAB_ATTRS} from '@pub/constants.js';
import {OAUTH_ACTION} from '@pub/comp/oauth_button';
import {Text} from '@pub/comp/text';
import {OS_ITEMS} from '@pub/comp/os/index.js';
import {Form_input, Form_dropdown, PASSWORD_KIND} from '@pub/comp/form';
import {Email_input, Password_input, Oauth_list} from './common.js';
import {MAX_EMAIL_LEN, APP_NAME_FIELD,
    APP_OS_FIELD} from './constants.js';
import {handle_signup} from './handlers.js';
import * as ccns from './common.module.less';

const APP_NAME_VARS = [
    'Constellation locator',
    'Four in row',
    'Heroes of Spell and Science',
    'Buckle Clash',
    'Bottle Flip',
    'Bounce Ball',
    'Cut the Hope',
];

const get_app_name = ()=>
    APP_NAME_VARS[Math.floor(Math.random()*APP_NAME_VARS.length)];

function SU_inputs(){
    return <>
      <Email_input/>
      <Password_input password_kind={PASSWORD_KIND.SIGNUP}/>
      <div className={ccns.separator}/>
      <Form_input className={ccns.input} title="App name"
        field={APP_NAME_FIELD} max_len={MAX_EMAIL_LEN}
        placeholder={get_app_name()} hint="what is your app name"/>
      <Form_dropdown title="App platform" options={OS_ITEMS}
        field={APP_OS_FIELD}/>
    </>;
}

function SU_alts(){
    return <div className={ccns.alts}>
      <Text.xxs className={ccns.or} tertiary>or</Text.xxs>
      <Oauth_list action={OAUTH_ACTION.SIGNUP}/>
    </div>;
}

export const meta = {
    title: 'Create your account to start making extra revenue!',
    submit_label: 'Sign up',
    form_comp: SU_inputs,
    nav_href: ROUTES.AUTH_SIGNIN,
    nav_label: 'Already have an account? Log in',
    nav_test_id: 'signin',
    disclaimer: <Text.xxs>By signing up, you agree to Bright SDK's{' '}
        <a href={PRIVACY_POLICY_LINK} {...NEW_TAB_ATTRS}>Privacy Policy</a>
    </Text.xxs>,
    alts: SU_alts,
    on_submit: handle_signup,
};
